
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sitemap/doctors-type-education-level-specialty-city-fa-5.xml",
      function () {
        return require("private-next-pages/sitemap/doctors-type-education-level-specialty-city-fa-5.xml.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sitemap/doctors-type-education-level-specialty-city-fa-5.xml"])
      });
    }
  